import { inventoryDuckCreator } from 'axl-ducks';

const inventoryDuck = inventoryDuckCreator();

export default inventoryDuck;
